<template>
  <div class="container">
    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="isShowIndex"></HeaderRegion>
   <div class="news-box">
      <div class="news-info">
        <div class="news-info-title">
          系统
        </div>
        <div class="news-content">
          <div class="news-content-one" v-for="item in newsList">
            <div class="news-content-left" v-html="item.content">
              {{item.content}}
            </div>
            <div class="news-content-right">
              <div>
                {{item.time2}}
              </div>
              <div>
                {{item.time1}}
              </div>
            </div>
          </div>

          <!-- 引入分页器 -->
          <div class="PagePagination">
            <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize" :total="total"></PagePagination>
          </div>
        </div>
      </div>
   </div>


    <!-- 底部展示区域 -->
    <BottomRegion ref="bottomForm"></BottomRegion>
  </div>
</template>

<script>
import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
import {baseImgUrl} from "../../api/config"
import PagePagination from "../../components/pagePagination/pagePagination"; //引入分页器

export default {
  name: "home",
  components: {
    HeaderRegion,
    BottomRegion,
    PagePagination
  },
  data() {
    return {
      headerForm: 0,
      isShowIndex: -1,
      newsList:[],
      baseImgUrl:baseImgUrl,
      pageIndex: 1,
      pageSize: 10,
      total:0
    };
  },
  created() {
    this.getData();
  },
  methods: {
    taskDetails(item){
      this.$router.push({
        path: "/task/taskDetail",
        query:{
          id:item.id
        }
      });
    },
    changePageInfo(current, size, total) {
      console.log(222)
      this.pageIndex = current;
      this.pageSize = size;
      this.total = total
      setTimeout(() => {
        //this.$refs.ProductFrom.getProductList()
      }, 100)
    },
    changePageIndex(page) {
      console.log(page);
      this.pageIndex = page;
      setTimeout(() => {
        this.getData();
      }, 100)
    },
    async getData() {
      try {
        let data = {
          pageNo:this.pageIndex,
          pageSize:this.pageSize,
        }
        const res = await this.$http.newsList(data);
        if (res.code == 200) {
          this.newsList=res.result.records;
          this.newsList.forEach((item,index)=>{
            let time=item.createTime.split(" ");
            console.log(time);
            this.newsList[index]['time1']=time[0];
            this.newsList[index]['time2']=time[1];
          })
          this.changePageInfo(this.pageIndex,res.result.size,res.result.total)
        } else {
          this.$message(res.message);
        }
      } catch (e) {

        throw e
      }
    },
  },
};
</script>


<style scoped>
.news-box{
  width: 1186px;
  margin: 0 auto 0;
  padding-top: 80px;
  min-height: 90vh;
}
.news-info{
  width: 100%;
  background-color: white;
  margin-top: 20px;
}
.news-info-title{
  color: #3A3A3A;
  box-sizing:border-box;
  font-size: 18px;
  font-weight: bold;
  padding: 17px 0 17px 45px;
  border-bottom: 1px solid #C7C7C7;
}
.news-content{
  padding: 0 51px 44px 51px;
}
.news-content-one{
  padding: 20px 0;
  border-bottom: 1px solid #B2B2B2;
  display: flex;
  justify-content: space-between;
}
.news-content-left{
  color: #3A3A3A;
  font-size: 15px;
  word-wrap:break-word;
  overflow: auto;
  word-break:break-all;
}
.news-content-right{
  width: 90px;
  color: #C7C7C7;
  font-size: 13px;
  flex-shrink: 0;
  margin-left: 50px;
}


</style>



// WEBPACK FOOTER //
// src/pages/userInfo/newsInfo.vue